import { session1, session2, session3, session4, session5, session6, session7, session8, session9, session10 } from './sessions';
import { completion } from './completion.js';

export const microcontroller = {
    id: "microcontroller",
    title: "Microcontroller Course",
    description: "Learn embedded systems programming with hands-on microcontroller projects",
    color: "#E74C3C",
    icon: "🎛️",
    level: "Intermediate",
    duration: "7 hours",
    students: "980",
    sessions: [
        session1,
        session2,
        session3,
        session4,
        session5,
        session6,
        session7,
        session8,
        session9,
        session10,
        completion
    ]
};
